import {
  PresentationTemplateEditor_PresentationTemplateBundleFragment,
  PresentationTemplateEditor_PresentationTemplateFragment,
  PresentationTemplateEditor_PresentationTemplatePageFragment,
} from './graphql/PresentationTemplateEditor.generated';

export interface PresentationTemplateEditorFormShape {
  id: string;
  displayName: PresentationTemplateEditor_PresentationTemplateFragment['displayName'];
  bundles: PresentationTemplateEditorBundle[];
  /**
   * True when the loaded source is a system template (e.g. Estate360). These
   * are read-only: the editor forces the save-as-new flow regardless of how it
   * was opened, so the source is never updated in place. Absent is treated as
   * not a system template.
   */
  isSystemTemplate?: boolean;
  /** Shared foreign templates must only be saved as a private copy. */
  isSharedTemplate?: boolean;
}

export interface PresentationTemplateEditorBundle {
  id: string;
  kind: PresentationTemplateEditor_PresentationTemplateBundleFragment['kind'];
  /**
   * Internal note for whoever builds a presentation from this template. Copied
   * onto the presentation bundle at creation and surfaced read-only there.
   */
  templateNotes?: PresentationTemplateEditor_PresentationTemplateBundleFragment['templateNotes'];
  /** When true, the bundle is skipped entirely by the generated output. */
  excludeFromOutput?: PresentationTemplateEditor_PresentationTemplateBundleFragment['excludeFromOutput'];
  /**
   * Instructions appended to the built-in AI prompt when a presentation is
   * created from this template. Only asset distribution diagram bundles use it.
   */
  additionalPromptContext?: PresentationTemplateEditor_PresentationTemplateBundleFragment['additionalPromptContext'];
  dividerTemplateBundleConfiguration?: PresentationTemplateEditor_PresentationTemplateBundleFragment['dividerTemplateBundleConfiguration'];
  waterfallTemplateBundleConfiguration?: PresentationTemplateEditor_PresentationTemplateBundleFragment['waterfallTemplateBundleConfiguration'];
  waterfallComparisonTemplateBundleConfiguration?: PresentationTemplateEditor_PresentationTemplateBundleFragment['waterfallComparisonTemplateBundleConfiguration'];
  documentSummaryTemplateBundleConfiguration?: PresentationTemplateEditor_PresentationTemplateBundleFragment['documentSummaryTemplateBundleConfiguration'];
  beneficiariesTemplateBundleConfiguration?: PresentationTemplateEditor_PresentationTemplateBundleFragment['beneficiariesTemplateBundleConfiguration'];
  insightsTemplateBundleConfiguration?: PresentationTemplateEditor_PresentationTemplateBundleFragment['insightsTemplateBundleConfiguration'];
  entitySummaryTemplateBundleConfiguration?: PresentationTemplateEditor_PresentationTemplateBundleFragment['entitySummaryTemplateBundleConfiguration'];
  pages: PresentationTemplateEditorPage[];
}

export interface PresentationTemplateEditorPage {
  id: string;
  kind: PresentationTemplateEditor_PresentationTemplatePageFragment['kind'];
  customPage?: PresentationTemplateEditor_PresentationTemplatePageFragment['customPage'];
  diagramPage?: PresentationTemplateEditor_PresentationTemplatePageFragment['diagramPage'];
  coverPage?: PresentationTemplateEditor_PresentationTemplatePageFragment['coverPage'];
}

export enum PresentationTemplateEditorStage {
  Error = 'Error',
  Loading = 'Loading',
  Template = 'Template',
  Page = 'Page',
}
